export const DISCOUNT_PRICE_COLOR = '#FF7070';
export const INCREDIBLE_DISCOUNTS_PRICE_COLOR = '#399F26';
